const chargerDetailsMap = {
  displayName: "Display Name",
  siteId: "Site ID",
  serialNumber: "Serial Number",
  status: "Status",
  sku: "SKU",
  partNumber: "Part Number",
  operatingVoltage: "Operating Voltage",
  ratedCurrent: "Rated Current",
  phaseCount: "Phase Count",
  firmwareVersion: "Firmware Version",
  wifiConfig: "WiFi Config",
  timezone: "Timezone",
  lastReportedAt: "Last Reported At",
  createdAt: "Created At",
  isConnected: "Is Connected",
  activeConnection: "Active Connection",
  commissioningStatus: "Commissioning Status",
  isRetired: "Is Retired",
  hoControl: "Enabled",
  dlbEnabled: "DLB Enabled",
  warrantyStartDate: "Warranty Start Date",
  warrantyDueDate: "Warranty Due Date",
  warrantyPeriod: "Warranty Period (years)",
  modelName: "Model Name",
  phaseMode: "Phase Mode",
};

const fieldGroups = [
  {
    title: "Device Information",
    keys: [
      "displayName",
      "serialNumber",
      "siteId",
      "sku",
      "partNumber",
      "firmwareVersion",
      "modelName",
      "isRetired",
      "status",
      "createdAt",
      "lastReportedAt",
      "timezone",
    ],
  },
  {
    title: "Partner Integration",
    keys: ["hoControl"],
  },
  {
    title: "Connectivity & Configuration",
    keys: ["activeConnection", "commissioningStatus", "dlbEnabled", "wifiConfig", "isConnected"],
  },
  {
    title: "Electrical Specs",
    keys: ["operatingVoltage", "phaseCount", "phaseMode", "ratedCurrent"],
  },
  {
    title: "Warranty",
    keys: ["warrantyDueDate", "warrantyPeriod", "warrantyStartDate"],
  },
];

const GROUP_ICONS = {
  "Device Information": { emoji: "🔌", color: "orange" },
  "Partner Integration": { emoji: "🤝", color: "green" },
  "Connectivity & Configuration": { emoji: "📡", color: "blue" },
  "Electrical Specs": { emoji: "⚡", color: "purple" },
  Warranty: { emoji: "🛡", color: "yellow" },
};

export { chargerDetailsMap, fieldGroups, GROUP_ICONS };
